import { Component, OnInit, HostListener, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { first } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AlertService, ConnectionService, ConnectorService, Constant } from "../_services";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-conntrigger',
  templateUrl: './connection.trigger.html'
})
export class ConnectionTriggerComponent implements OnInit {
  Connectors = null;
  ConnectorSelected = null;
  selected = true;
  url: string = "";
  submitted = false;
  AutomationApiData = null;
  Connector1: string;
  loading = false;
  key_nm: string;
  triggerEvents = null;
  Continue = 'Authanticate';
  TenantID: string;
  account = false;
  cID: string;
  loading1 = true;
  closeResult = '';
  clientsecret: string;
  eventtid: string;
  AuthType: string;
  cname: string;
  @Input() ConnectorID;
  label_nm: string;
  popch = false;
  flg: string = 'T';
  TriggerSelect = false;
  form: FormGroup;
  formTeam: FormGroup;
  form2: FormGroup;
  finaltoken = null;
  showmessage: string;
  auid: string;
  checkonparent = false;
  TriggerDetail = null;
  showWrongTokenMessage: string = '';
  LastUsedToken = null;
  openAuth = null;
  error: String;
  client_id: string;
  scope: string;
  redirect_uri: string;
  TeamsReturnURL: string;
  uid: string;
  Autharization_URL: string;
  hideElement: boolean;
  OpenAuthenticationDeail = null;
  OpenAuthenticationDetail = null;
  @Input() RefereshToken: string;
  constructor(
    private connectionservice: ConnectionService,
    private alertService: AlertService,
    private ConnectionService: ConnectionService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private formBuilderTeam: FormBuilder,
    private formBuilder2: FormBuilder,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal) {
  }
  get f() { return this.form.controls; }
  get f2() { return this.form2.controls; }
  get fTeam() { return this.formTeam.controls; }
  ngOnInit() {

   // this.connectionservice.PostChatMessage();
     
    this.url = environment.logoURL;
    this.uid = this.route.snapshot.params['uid'];
    try {
      this.route.firstChild.params.subscribe(params => {

        this.auid = params['auid'];
      });
    } catch (e) {

    }
    this.TeamformInttilaization();
    if (this.RefereshToken) {
      this.spinner.show();
      const rt = this.RefereshToken;
      this.connectionservice.getconnectoropenAuthentication(this.auid, 'T')
        .pipe(first())
        .subscribe(ConnectorID => {
          this.ConnectorID = ConnectorID;
          this.openAuthenticationTrigger(this.ConnectorID.cid, rt);
        });
    }
  //  this.PostMessagefromchanneltoBot();
    this.ConnectorSelected = [];
    this.ConnectionService.getAll()
      .pipe(first())
      .subscribe(Connectors => {
        this.Connectors = Connectors,
          this.ConnectorSelected = Connectors,

          this.ConnectionService.getSavedTriggerDetail(this.auid)
            .pipe(first())
            .subscribe(TriggerDetail => {
              this.TriggerDetail = TriggerDetail;
              if (this.TriggerDetail) {
                this.Modify(this.TriggerDetail);
              }


            });
      });



  }
  onChangeEvent(event: any) {
    if (event.target.value) {
      this.hideElement = false;
    } else {
      this.hideElement = true;
    }
    this.TenantID = event.target.value;
    this.TeamsReturnURL = environment.TeamsReturnURL;
  }

  Modify(TriggerDetail) {
    if (TriggerDetail.uId) {
      this.AddTriggerMOD(TriggerDetail);
    }
  }

  AddTriggerMOD(TriggerDetail) {

    this.selected = false;
    var result = this.Connectors.find(x => x.uId === TriggerDetail.uId);
    this.cname = result.connectorName;
    this.AuthType = result.authType;
    this.cID = TriggerDetail.uId;

    this.formInttilaization();
    if (this.TriggerDetail.eventID === null) {
      this.TriggerDetail.eventID = 0;
    }
    this.form2Inttilaization(TriggerDetail)
    this.ConnectionService.getevent(this.cID, 'T')
      .pipe(first())
      .subscribe(TriggerEvents => {
        this.triggerEvents = TriggerEvents
      });
    if (this.AuthType === 'oauth') {
      this.AuthType = ' oauth authentication is in progress';
      this.popch = false;
      if (TriggerDetail.access_token) {
        this.TriggerSelect = true;
      }

    } else {
      this.formInttilaization();
      this.SelectedConnectorDetail(TriggerDetail);
      this.AuthType = '';
      this.popch = true;
      this.TriggerSelect = true;
    }
    this.Connector1 = TriggerDetail.uId;


  }
  AddTrigger(cid: string, content) {
    this.spinner.show();
    this.uid = this.route.snapshot.params.uid;
    try {
      this.route.firstChild.params.subscribe(params => {
        //let auid = +params['auid'];
        this.auid = params['auid'];
      });
    } catch (e) {

    }

    // this.ngOnInit();
    this.selected = false;
    var result = this.Connectors.find(x => x.uId === cid);
    this.cname = result.connectorName;
    this.AuthType = result.authType;
    this.cID = cid;
    this.formInttilaization();
    this.TeamformInttilaization();
    if (this.AuthType === 'oauth') {
      this.AuthType = ' oauth authentication is in progress';
      this.popch = false;
      this.openAuthentication(this.cID);
      this.hideElement = true;
      this.label_nm = '';
      this.key_nm = '';
      // this.SaveDetail();
    } else {
      this.spinner.hide();
      this.lastUSedToken(cid, this.uid);
      this.popch = true;
      this.SelectedConnectorDetail(this.TriggerDetail);
      this.AuthType = '';
      this.popch = true;

    }
    this.Connector1 = cid;
    this.open(content);

  }

  ChangeTrigger() {
    try {
      this.form2.get('eventID').setValue(0);
    } catch (e) {

    }
    this.selected = true;
    this.TriggerSelect = false;
    this.showmessage = '';
    this.connectionservice.removeentry(this.auid, 'T')
      .pipe(first())
      .subscribe(data => {

        if (!data.isSuccess) {
          this.alertService.error(data.message);
        } else {
          //this.alertService.clear();
          //this.alertService.success(data.message);
          //this.ngOnInit();
        }
      });

  }
  selectTrigger(t) {
    if (t == "0") {

    }
    else {
      this.Saveevent();
    }

  }


  openAuthentication(cId) {
    this.uid = this.route.snapshot.params.uid;
    this.scope = 'incoming-webhook';
    this.TeamsReturnURL = environment.TeamsReturnURL;
    this.redirect_uri = environment.returnURL + this.uid + '/trigger/' + this.auid;
    const user_scope = '';
    try {
      this.route.firstChild.params.subscribe(params => {

        this.auid = params['auid'];
      });
    } catch (e) {

    }
    this.connectionservice.getOpenAuthenticationConnectorDetail(cId)
      .pipe(first())
      .subscribe(
        OpenAuthenticationDeail => {
          this.OpenAuthenticationDeail = OpenAuthenticationDeail
          this.client_id = this.OpenAuthenticationDeail.clientid; 
          this.Autharization_URL = this.OpenAuthenticationDeail.authorizationURL;
          this.clientsecret = this.OpenAuthenticationDeail.clientsecret;
          this.spinner.hide();
        });

  }
  onSubmit2() {
    this.alertService.success('OK', { keepAfterRouteChange: true });
  }

  get formExitValidation() {

    try {
      this.eventtid = this.form2.get('eventID').value;
    } catch (e) {
      this.eventtid = '0';
    }

    if (this.eventtid != '0') {
      return this.checkonparent = true;
    } else {
      this.alertService.error('Complete all connector requirement for procced ', { keepAfterRouteChange: true });
      return this.checkonparent = false;
    }
  }
  onSubmit() {
    this.submitted = true;
    this.alertService.clear();
    if (this.form.invalid) {

      return;
    }
    this.showWrongTokenMessage = '';
    this.loading = true;
    this.connectionservice.GetQ2ETriggerAuthenticate(this.AutomationApiData.testURL, this.form.get('autoUserID').value)
      .pipe(first())
      .subscribe(
        data => {
          this.submitted = false;
          if (data == 'Authenticated Successfully.') {
            this.SaveDetail();
          }
          else {
            this.alertService.error(data.message);
            this.showmessage = 'Wrong ' + this.AutomationApiData.label_nm;
          }
        },
        error => {
          this.loading = false;
          // this.alertService.error('Invalid ' + this.AutomationApiData.label_nm);
          this.showWrongTokenMessage = 'Invalid ' + this.AutomationApiData.label_nm;
        });

  }

  onSubmitTeam() {
    this.submitted = true;
    this.alertService.clear();
    if (this.formTeam.invalid) {
      return;
    }
    localStorage.setItem('uid', this.uid);
    localStorage.setItem('auid', this.auid);
    localStorage.setItem('tenentid', this.TenantID);
    localStorage.setItem('client_id', this.client_id);
    localStorage.setItem('clientsecret', this.clientsecret);
    localStorage.setItem('TeamsReturnURL', this.TeamsReturnURL);
    localStorage.setItem('For', 'trigger');
    this.connectionservice.savedetail(this.cname == "Slack" ? this.form.value : this.formTeam.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {

            // this.closeModal();
            if (this.AuthType != ' oauth authentication is in progress') {
              this.modalService.dismissAll();
              this.showmessage = '';
              this.eventInitalize();
              this.alertService.success(data.message, { keepAfterRouteChange: true });
            } else {
              //this.showmessage = data.message;
            }
            // this.someEvent.next('somePhone');

          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });

    this.loading = true;
  }
  SaveDetail() {
    this.connectionservice.savedetail(this.form.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {
            if (this.AuthType != ' oauth authentication is in progress') {
              this.modalService.dismissAll();
              this.showmessage = '';
              this.alertService.success(data.message, { keepAfterRouteChange: true });
              this.eventInitalize();
            } else {
              //this.showmessage = data.message;
            }


          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  eventInitalize() {
    this.TriggerSelect = true;
    this.form2Inttilaization(this.TriggerDetail);
    this.ConnectionService.getevent(this.cID, 'T')
      .pipe(first())
      .subscribe(TriggerEvents => {
        this.triggerEvents = TriggerEvents
      });

  }
  open(content) {

    this.showWrongTokenMessage = '';

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  public closeModal($event): void {
    this.closeResult = `Dismissed ${this.getDismissReason("g")}`;
    // this.closeBtn.nativeElement.close();
    // this.getDismissReason('ss');
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  private Saveevent() {
    this.connectionservice.savedetail(this.form2.value)
      .pipe(first())
      .subscribe(
        data => {
          this.loading = false;
          if (!data.isSuccess) {
            this.alertService.error(data.message);
          }
          else {



          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }
  private TeamformInttilaization() {
    this.formTeam = this.formBuilderTeam.group({
      autoUserID: [''],
      TenantID: ['', Validators.required],
      cID: this.auid,
      flag: this.flg,
      uId: this.cID
    });
  }
  private formInttilaization() {
    this.form = this.formBuilder.group({

      autoUserID: ['', Validators.required],
      cID: this.auid,
      flag: this.flg,
      uId: this.cID
    });
  }
  private SelectedConnectorDetail(TriggerDetail) {
    this.connectionservice.SelectedConnectorDetail(this.cID)
      .pipe(first())
      .subscribe(
        AutomationApiData => {
          this.AutomationApiData = AutomationApiData
          this.label_nm = AutomationApiData.label_nm;
          this.key_nm = AutomationApiData.key_nm;
          //if (TriggerDetail.autoUserID) {
          //  this.f.autoUserID.setValue(TriggerDetail.autoUserID);
          //}

        });
  }

  private form2Inttilaization(TriggerDetail) {
    let eventvar = 0;
    if (TriggerDetail) {
      eventvar = this.TriggerDetail.eventID;
    }
    this.form2 = this.formBuilder2.group({
      eventID: [eventvar],
      autoUserID: [''],
      cID: this.auid,
      flag: 'E',
      uId: this.cID
    });
  }
  openAuthenticationTrigger(cId, rt) {
    this.redirect_uri = environment.returnURL + this.uid + '/trigger/' + this.auid;

    const user_scope = '';

    this.connectionservice.getOpenAuthenticationConnectorDetail(cId)
      .pipe(first())
      .subscribe(
        OpenAuthenticationDeail => {

          this.OpenAuthenticationDetail = OpenAuthenticationDeail;

          this.connectionservice.postSlackOpenAuthentication(
            this.OpenAuthenticationDetail.clientid,
            this.OpenAuthenticationDetail.clientsecret,
            this.OpenAuthenticationDetail.accesstokenreq,
            rt,
            this.redirect_uri)
            .pipe(first())
            .subscribe(
              data => {
                this.finaltoken = data;
                if (this.finaltoken.ok) {

                  this.connectionservice.PostRefereshTokenTrigger(this.auid, this.uid, this.finaltoken)
                    .pipe(first())
                    .subscribe(
                      data => {
                        if (data.isSuccess) {
                          this.spinner.hide();
                          this.alertService.success(data.message, { keepAfterRouteChange: true });
                          this.TriggerSelect = true;
                        }
                      },
                      error => {

                      })
                } else {
                  this.spinner.hide();
                  this.alertService.success('Token Expire Please Try Again', { keepAfterRouteChange: true });
                }
              },
              error => {

              })




          //this.OpenAuthenticationDeail = OpenAuthenticationDeail
          //this.client_id = this.OpenAuthenticationDeail.clientid; // '1023067552646.2142156557220';
          //this.Autharization_URL = this.OpenAuthenticationDeail.authorizationURL;
          //this.ConnectorIDForParent.emit(this.OpenAuthenticationDeail);
        });

  }


  private lastUSedToken(cId, uId) {
    this.ConnectionService.getLastUsedTiken(cId, uId)
      .pipe(first())
      .subscribe(LastUsedToken => {
        this.LastUsedToken = LastUsedToken;
        if (this.LastUsedToken) {
          //this.f.autoUserID.setValue(LastUsedToken.token);
        }
      });
  }
}
